// @flow

import styled, { css } from 'styled-components';
import { media, zIndexMap } from '../../../../helpers';
import type { Theme } from '../../../../types';

type Props = {
  isOpen: boolean,
};

const Container = styled<any, Theme, Props>('div')`
  transition: all 0.3s ease-in-out;
  z-index: ${zIndexMap.pdbCompare};
  bottom: -${props => props.theme.pdbCompare.height};
  background-color: white;
  position: fixed;
  border-radius: 4px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  box-shadow: ${props => props.theme.pdbCompare.shadow};
  flex-direction: column;
  align-items: center;
  min-width: 45rem;
  transform: translateX(-50%);
  margin: auto;
  left: 50%;
  display: none;

  ${media.lg(css`
    display: block;
  `)}

  ${props => props.isOpen && css`
    bottom: 0;
  `};
`;

export default Container;
